import { render, staticRenderFns } from "./Unsubscribe.vue?vue&type=template&id=52478b2c&scoped=true"
import script from "./Unsubscribe.vue?vue&type=script&lang=js"
export * from "./Unsubscribe.vue?vue&type=script&lang=js"
import style0 from "./Unsubscribe.vue?vue&type=style&index=0&id=52478b2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52478b2c",
  null
  
)

export default component.exports